import { IEnergyDeclaration } from 'models/IEnergyLabel';
import { NO_ELEMENT, rm } from 'utils';
import { getQaDataAttr } from '@bygghemmait/utilities';
import { EnergyArrow } from 'components/Energy/arrow';
import cn from 'classnames';
import styles from './styles.scss';
import { Savings } from 'views/ProductPage/savings';
import { isMobile as isMobileSelector } from 'components/Shared/responsive';
import { useSelector } from 'react-redux';

type OwnProps = Pick<
  IEnergyDeclaration,
  'efficiencyArrow' | 'efficiencyLabel' | 'efficiencyDeclarationUrl' | 'productId'
> & {
  appearance?: 'small' | 'smallMedium' | 'medium' | 'large';
  classNames?: string;
  arrowWrapperClassName?: string;
  showSavings?: boolean;
  marginBottom?: boolean;
};

export const EnergyData = ({
  efficiencyArrow,
  efficiencyDeclarationUrl,
  productId,
  appearance = 'medium',
  classNames,
  arrowWrapperClassName,
  showSavings = false,
  marginBottom
}: OwnProps) => {
  const isMobile = useSelector(isMobileSelector);

  const arrow = efficiencyArrow && (
    <EnergyArrow
      productId={productId}
      appearance={appearance}
      wrapperClassName={cn(styles.energyArrowWrapper, arrowWrapperClassName)}
      efficiencyArrow={efficiencyArrow}
      className={styles.energyArrow}
    />
  );

  const productDeclaration = efficiencyDeclarationUrl && (
    <a
      href={efficiencyDeclarationUrl}
      target="_blank"
      rel="noreferrer"
      className={styles.productLink}
    >
      {rm('product_energydeclaration_title')}
    </a>
  );

  const savings = isMobile || !showSavings ? undefined : <Savings />;
  const shouldRender = arrow || productDeclaration || savings;

  return shouldRender ? (
    <div
      className={cn(styles.energyContainer, classNames, {
        [styles.marginBottom]: marginBottom
      })}
      {...getQaDataAttr(`EnergyContainer`)}
    >
      {arrow}
      {productDeclaration}
      {savings}
    </div>
  ) : (
    NO_ELEMENT
  );
};
